import React, { useLayoutEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { toast } from "react-hot-toast";
import { Input, Select, TextArea } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import useCookie from "hooks/useCookie";

import { encryptData } from "config/config";
import {
  getSingleCityTestimonialById,
  updateCityTestimonial,
  getCityDropdown,
} from "services/citypages/citytestimonials";
import useFullPageLoader from "hooks/useFullPageLoader";
import { Avatar } from "@mui/material";

const UpdateCityTestimonial = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const { cookies } = useCookie();

  // master data states
  const [allCity, setAllCity] = useState([]);

  const [data, setData] = useState({
    rank: "",
    stateid: "",
    studentName: "",
    yearOfStudy: "",
    studentImage: "",
    media: "",
    description: "",
  });

  const [errorField, setErrorField] = useState({
    rank: "",
    stateid: "",
    studentName: "",
    yearOfStudy: "",
    studentImage: "",
    media: "",
    description: "",
  });

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!data.rank) {
      errorField["rank"] = "Please Enter Rank";
      formIsValid = false;
    }

    if (!data.description) {
      errorField["description"] = "Please Enter Description";
      formIsValid = false;
    }
    if (!data.stateid) {
      errorField["stateid"] = "Please Select city";
      formIsValid = false;
    }
    if (!data.studentName) {
      errorField["studentName"] = "Please Enter student Name";
      formIsValid = false;
    }
    if (!data.yearOfStudy) {
      errorField["yearOfStudy"] = "Please Enter year of study";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };

  //*********************Submit Student Testimonial Handler********************************** */
  const submitTestimonialHandler = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      if (!data.rank) {
        toast.error("Please Enter Rank");
      } else if (!data.stateid) {
        toast.error("Please Select city");
      } else if (!data.studentName) {
        toast.error("Please Enter Student Name");
      } else if (!data.yearOfStudy) {
        toast.error("Please Enter year of study");
      } else if (!data.description) {
        toast.error("Please Enter Description");
      } else {
        setSubmitLoading(true);
        const formData = new FormData();
        data.studentImage?.name &&
          formData.append("studentImage", data.studentImage);

        data.media?.name && formData.append("media", data.media);

        formData.append(
          "reqData",
          encryptData({ ...data, access_token: cookies })
        );
        try {
          const res = await updateCityTestimonial(formData);
          if (res.code === 200) {
            toast.success(res.message);
            setSubmitLoading(false);
            navigate(-1);
          } else {
            toast.error(res.message);
            setSubmitLoading(false);
          }
        } catch (err) {
          toast.error(err?.response?.data?.message || err.message);
          setSubmitLoading(false);
        }
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  //   onChange Handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // --------------- getting all required masters data ----------------//
  useLayoutEffect(() => {
    const getCityDropdownData = async () => {
      try {
        const res = await getCityDropdown();
        if (res.code === 200) {
          setAllCity(res.data.statewisecenters || []);
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
    };

    getCityDropdownData();
  }, []);

  //   ---------------  get single testimonial's detail ---------------//
  useLayoutEffect(() => {
    const getSingleTestimonial = async (id) => {
      try {
        showLoader();
        const res = await getSingleCityTestimonialById({
          id,
        });
        hideLoader();
        if (res.code === 200) {
          setData(
            {
              ...res.data.Statewisetestimonial,
              stateid: res.data.Statewisetestimonial?.stateid,
            } || {}
          );
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
    };
    getSingleTestimonial(id);
  }, []);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5 d-flex justify-content-between">
                <h4 className="Title">
                  <Link to={-1}>
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  Update Student Testimonial
                </h4>
              </div>
            </div>

            <div className="row mt-1">
              {loader}
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitTestimonialHandler}>
                  <div className="form-group row mt-1">
                    <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-sm-12 col-form-label">
                          <Input
                            type="text"
                            name="rank"
                            value={data.rank}
                            onChange={onChangeHandler}
                            placeholder="Enter rank"
                            className={`form-control`}
                            maxLength={30}
                            label={"Rank"}
                            error={errorField.rank}
                            required
                            {...submitButtonElement}
                          />
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <Input
                            type="text"
                            name="studentName"
                            value={data.studentName}
                            onChange={onChangeHandler}
                            placeholder="Enter Student Name"
                            className={`form-control `}
                            maxLength={30}
                            label={"Student Name"}
                            error={errorField.studentName}
                            required
                            {...submitButtonElement}
                          />
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <div className="row">
                            <div className="col-sm-9">
                              <Input
                                type="file"
                                name="studentImage"
                                onChange={({ target }) =>
                                  setData({
                                    ...data,
                                    studentImage: target.files[0],
                                  })
                                }
                                placeholder="Select Student Image"
                                className={`form-control`}
                                accept="image/png, image/jpeg,image/jpg,image/webp"
                                label={"Student Image"}
                                error={errorField.studentImage}
                                required
                                {...submitButtonElement}
                              />
                            </div>
                            <div className="col-sm-3 col-form-label d-flex justify-content-center align-items-center">
                              <Avatar
                                alt={data.studentName}
                                src={
                                  data.studentImage?.name
                                    ? URL.createObjectURL(data.studentImage)
                                    : data.studentImage
                                }
                                sx={{ width: 66, height: 66 }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <Input
                            type="number"
                            name="yearOfStudy"
                            value={data.yearOfStudy}
                            onChange={onChangeHandler}
                            placeholder="Enter Year Of Study"
                            className={`form-control `}
                            maxLength={4}
                            label={"Year of study"}
                            error={errorField.yearOfStudy}
                            required
                            {...submitButtonElement}
                          />
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <Select
                            name="stateid"
                            placeholder="Select Centre"
                            onChange={onChangeHandler}
                            value={data.stateid}
                            className={`form-control `}
                            label={"Select State"}
                            error={errorField.stateid}
                            required
                            {...submitButtonElement}
                          >
                            <option value="">Select State</option>
                            {allCity &&
                              allCity.map(({ id, statename }) => {
                                return (
                                  <option value={id} key={id}>
                                    {statename}
                                  </option>
                                );
                              })}
                          </Select>
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <Input
                            type="file"
                            name="media"
                            onChange={({ target }) =>
                              setData({
                                ...data,
                                media: target.files[0],
                              })
                            }
                            placeholder="Select Media"
                            className={`form-control `}
                            label={"Media"}
                            error={errorField.media}
                            accept="video/mp4,video/x-m4v,video/*"
                            required
                            {...submitButtonElement}
                          />
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <video
                            controls
                            autoPlay
                            src={data.media}
                            width="100%"
                            height={400}
                          >
                            Your browser does not support the video tag.
                          </video>
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <TextArea
                            type="text"
                            name="description"
                            value={data.description}
                            onChange={onChangeHandler}
                            placeholder="Enter Category Description"
                            className={` form-control`}
                            rows={7}
                            maxLength={75}
                            label={"Description"}
                            error={errorField.description}
                            required
                            {...submitButtonElement}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <Button type="submit" {...submitButtonElement}>
                      {"Update"}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateCityTestimonial;
